export const PRODUCT_FORMAT_OPTIONS = [
    'Package',
    'Void',
    'Non Dox',
    'Dox',
    'Others'
] as const;

export interface ProductFormat {
    _id: string;
    name: typeof PRODUCT_FORMAT_OPTIONS[number];
    status: 'Active' | 'Inactive';
    createdAt: string;
    updatedAt: string;
    createdBy?: string;
    updatedBy?: string;
}

export interface ProductFormatFormData {
    name: string;
    status: 'Active' | 'Inactive';
}

export interface ProductFormatFilters {
    status?: string;
}

export interface ProductFormatSearchParams {
    search?: string;
    filters?: ProductFormatFilters;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface ProductFormatApiResponse {
    success: boolean;
    data: ProductFormat[] | {
        data: ProductFormat[];
        total: number;
        page: number;
        limit: number;
        totalPages: number;
    };
    message?: string;
    timestamp?: string;
}


